import { createFileRoute } from "@tanstack/react-router";
import { TailwindPluginDemo } from "@/components/design-system/TailwindPluginDemo";

export const Route = createFileRoute(
  "/demo/design-system/theming/tailwind-plugin",
)({
  component: TailwindPluginDemo,
});
